/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Step_ResumeInputs */

const en_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const de_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf`)
};

const fr_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum`)
};

const it_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum`)
};

const nl_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const pl_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const fi_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelo`)
};

const da_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const sv_onboarding_step_resume = /** @type {(inputs: Onboarding_Step_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Onboarding_Step_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_step_resume = /** @type {((inputs?: Onboarding_Step_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Step_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_step_resume(inputs)
	if (locale === "fr") return fr_onboarding_step_resume(inputs)
	if (locale === "es") return es_onboarding_step_resume(inputs)
	if (locale === "it") return it_onboarding_step_resume(inputs)
	if (locale === "nl") return nl_onboarding_step_resume(inputs)
	if (locale === "pl") return pl_onboarding_step_resume(inputs)
	if (locale === "fi") return fi_onboarding_step_resume(inputs)
	if (locale === "da") return da_onboarding_step_resume(inputs)
	if (locale === "sv") return sv_onboarding_step_resume(inputs)
	return en_onboarding_step_resume(inputs)
});